import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { buscarPessoasService } from "../../../services/buscarPessoasService";

export const useBuscarPessoas = () => {
  const [pessoas, setPessoas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetch = async () => {
    setIsLoading(true);
    const data = await buscarPessoasService();

    const formattedData = (data ?? []).map((item: any) => {
  const usuario = item.Usuario;
  const lead = item.Leads;

  const nomeUsuario =
    usuario
      ? `${usuario.nome ?? ""} ${usuario.sobrenome ?? ""}`.trim()
      : (lead?.nome ?? "Desconhecido");

  const celular =
    usuario?.celular ?? lead?.celular ?? "N/A";

  return {
    id: item.id,
    pessoaId: item.id,
    nomeUsuario: nomeUsuario || "Desconhecido",
    celular,
  };
});

    setPessoas(formattedData);
    setIsLoading(false);
  };

  useEffect(() => {
    fetch();
  }, []);

  // Retorna as variáveis de estado para o componente que utiliza este hook
  return { pessoas, isLoading, fetch };
};
